import axios from 'axios';

const api = axios.create({
  // Same-origin in production (backend serves the frontend); localhost in dev
  baseURL: process.env.REACT_APP_API_URL
    || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001')
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('tz_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('tz_token');
      localStorage.removeItem('tz_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Fetch a document with the auth header and open it in a new tab.
// (A plain <a href> can't send the JWT, and the download route is protected.)
export const openDocument = async (id) => {
  const res = await api.get(`/api/documents/${id}/download`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(res.data);
  window.open(url, '_blank', 'noopener');
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

export default api;
